module.exports = __webpack_public_path__ + "static/media/Sumaria-LG-gainon_logo.9a973ba0.png";